export { default as LaboratoristasList } from './Listar';
export { default as LaboratoristaCrear } from './Crear';